export const DktDots = ({
  childrenArray,
  slideIndex,
  className = '',
}: {
  childrenArray: React.ReactNode[]
  slideIndex: number
  className?: string
}) => {
  return (
    <div
      className={`dkt-slider-dots absolute bottom-2 md:bottom-4 left-1/2 z-30 flex h-[8px] -translate-x-1/2 items-center gap-2 ${className}`}
    >
      {childrenArray.map((_, index) => {
        const isActive = index === slideIndex

        return (
          <span
            key={index}
            aria-hidden
            className={`h-1.5 rounded-round transition-all duration-500 motion-reduce:transition-none ${
              isActive ? 'w-8 bg-white' : 'w-1.5 bg-white/40'
            }`}
          />
        )
      })}
    </div>
  )
}
